import { useParams } from "react-router-dom";
import PageHeader from "../../../Layout/PageHeader";
import DynamicDetailGrid from "../../../Components/Grid/DynamicDetailGrid";
import { ChevronDown, ChevronUp, Trash3Fill } from "react-bootstrap-icons";
import { useState } from "react";
import Table, { Column } from "../../../Components/Tables/Table";
import { OrderPickTicketDetailTable } from "../../../Data/outbound";
import CommonConfirmationModal from "../../../Components/Modals/CommonConfirmationModal";

export default function OrderShipmentDetail() {
  const { id } = useParams<{ id: string }>();
  const pageName = `Shipment Detail(${id})`;
  const [showConfModal, setShowConfModal] = useState(false);
  const handleConfClose = () => setShowConfModal(false);

  const onModalSubmit = (response: boolean) => {
    console.log(response);
    handleConfClose();
  };
  const handelDeleteAction = () => setShowConfModal(true);

  const [collapseStates1, setCollapseStates1] = useState<boolean[]>([false]);
  const toggleCollapse1 = (index: number) => {
    const updatedCollapseStates = [...collapseStates1];
    updatedCollapseStates[index] = !updatedCollapseStates[index];
    setCollapseStates1(updatedCollapseStates);
  };

  const [collapseStates2, setCollapseStates2] = useState<boolean[]>([false]);
  const toggleCollapse2 = (index: number) => {
    const updatedCollapseStates = [...collapseStates2];
    updatedCollapseStates[index] = !updatedCollapseStates[index];
    setCollapseStates2(updatedCollapseStates);
  };

  const [collapseStates3, setCollapseStates3] = useState<boolean[]>([false]);
  const toggleCollapse3 = (index: number) => {
    const updatedCollapseStates = [...collapseStates3];
    updatedCollapseStates[index] = !updatedCollapseStates[index];
    setCollapseStates3(updatedCollapseStates);
  };

  const [collapseStates4, setCollapseStates4] = useState<boolean[]>([false]);
  const toggleCollapse4 = (index: number) => {
    const updatedCollapseStates = [...collapseStates4];
    updatedCollapseStates[index] = !updatedCollapseStates[index];
    setCollapseStates4(updatedCollapseStates);
  };

  const columns: Column[] = [
    {
      name: "Shipment Line",
      selector: (row: { shipmentLine: string }) => row.shipmentLine,
    },
    {
      name: "Location",
      selector: (row: { location: string }) => row.location,
    },
    {
      name: "Item Code",
      selector: (row: { itemCode: string }) => (
        <span title={row.itemCode.length > 15 ? row.itemCode : ""}>
          {row.itemCode.length > 15
            ? `${row.itemCode.slice(0, 15)}...`
            : row.itemCode}
        </span>
      ),
    },
    {
      name: "Description",
      selector: (row: { description: string }) => row.description,
    },
    {
      name: "UOM",
      selector: (row: { uom: string }) => row.uom,
    },
    {
      name: "Shipment #",
      selector: (row: { shipmentNumber: string }) => row.shipmentNumber,
    },
    {
      name: "Qty to Pick",
      selector: (row: { qtyToPick: string }) => row.qtyToPick,
    },
    {
      name: "Picked Qty",
      selector: (row: { pickedQty: string }) => row.pickedQty,
    },
  ];

  const OutbounDetailsData = {
    OutboundDetailsExpanded: [
      {
        label: "Shipment #",
        value: (
          <>
            <span className="text-primary">PT-1001</span>
          </>
        ),
      },
      { label: "Ship-by Date", value: "03/11/2023" },
      { label: "Bill-to Code", value: "CS-478" },
      { label: "Order Date", value: "11/11/2023" },
      { label: "Warehouse", value: "Texas Warehouse" },

      {
        label: "Status",
        value: (
          <>
            <div className="text-dark w-auto px-4 badge asn-overview-status w-70 asn-overview-status-border-orange">
              Due Now
            </div>
          </>
        ),
      },
    ],

    OutboundDetailsDefault: [
      {
        label: "Shipment #",
        value: (
          <>
            <span className="text-primary">PT-1001</span>
          </>
        ),
      },
      { label: "Ship-by Date", value: "03/11/2023" },
      { label: "Bill-to Code", value: "CS-478" },
      { label: "Order Date", value: "11/11/2023" },
      { label: "Warehouse", value: "Texas Warehouse" },

      {
        label: "Status",
        value: (
          <>
            <div className="text-dark w-auto px-4 badge asn-overview-status w-70 asn-overview-status-border-orange">
              Due Now
            </div>
          </>
        ),
      },
    ],
  };
  return (
    <>
      <PageHeader listUrl={`/outbound/orders/details/${id}`} viewType={true} />
      <h5 className="text-start mt-1 mb-3">{pageName}</h5>

      <div className="my-2 bg-white rounded d-flex flex-column ">
        <div className="checkin-details col-12 bg-white col-12 py-1  px-2 rounded">
          {collapseStates1[0] ? (
            <div className="checkin-details row align-items-top d-flex bg-white col-12 m-0">
              <DynamicDetailGrid
                customClassName="row-p-0 col-11"
                isExpandable={false}
                columns={5}
                data={OutbounDetailsData.OutboundDetailsExpanded}
              />
              <div className=" col d-flex align-items-center gap-2">
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                      onClick={() => toggleCollapse1(0)}
                    >
                      {collapseStates1[0] ? <ChevronUp /> : <ChevronDown />}
                    </span>
                  </div>
                </div>
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse rounded-pill cursor-pointer ">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                      onClick={() => handelDeleteAction()}
                    >
                      <Trash3Fill />
                    </span>
                  </div>
                </div>
              </div>
              <div className="mt-2 bg-white rounded py-1 px-4 detail-table-scroll">
                <Table
                  columns={columns}
                  data={OrderPickTicketDetailTable}
                  CheckboxStatus={false}
                  isStripped={true}
                  customClassName="transferDetailsTable"
                />
              </div>
            </div>
          ) : (
            <div className="checkin-details row m-0 align-items-center d-flex bg-white col-12 ">
              <DynamicDetailGrid
                customClassName=" col-11 row-p-0"
                isExpandable={false}
                columns={5}
                data={OutbounDetailsData.OutboundDetailsDefault}
              />
              <div className=" col d-flex align-items-center gap-2">
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 "
                      onClick={() => toggleCollapse1(0)}
                    >
                      {collapseStates1[0] ? <ChevronUp /> : <ChevronDown />}
                    </span>
                  </div>
                </div>
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse rounded-pill cursor-pointer ">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                      onClick={() => handelDeleteAction()}
                    >
                      <Trash3Fill />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="my-2 bg-white rounded d-flex flex-column ">
        <div className="checkin-details col-12 bg-white col-12 py-1  px-2 rounded">
          {collapseStates2[0] ? (
            <div className="checkin-details row align-items-top d-flex bg-white col-12 m-0">
              <DynamicDetailGrid
                customClassName="row-p-0 col-11"
                isExpandable={false}
                columns={5}
                data={OutbounDetailsData.OutboundDetailsExpanded}
              />
              <div className=" col d-flex align-items-center gap-2">
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                      onClick={() => toggleCollapse2(0)}
                    >
                      {collapseStates2[0] ? <ChevronUp /> : <ChevronDown />}
                    </span>
                  </div>
                </div>
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse rounded-pill cursor-pointer ">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                      onClick={() => handelDeleteAction()}
                    >
                      <Trash3Fill />
                    </span>
                  </div>
                </div>
              </div>
              <div className="mt-2 bg-white rounded py-1 px-4 detail-table-scroll">
                <Table
                  columns={columns}
                  data={OrderPickTicketDetailTable}
                  CheckboxStatus={false}
                  isStripped={true}
                  customClassName="transferDetailsTable"
                />
              </div>
            </div>
          ) : (
            <div className="checkin-details row m-0 align-items-center d-flex bg-white col-12 ">
              <DynamicDetailGrid
                customClassName=" col-11 row-p-0"
                isExpandable={false}
                columns={5}
                data={OutbounDetailsData.OutboundDetailsDefault}
              />
              <div className=" col d-flex align-items-center gap-2">
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 "
                      onClick={() => toggleCollapse2(0)}
                    >
                      {collapseStates2[0] ? <ChevronUp /> : <ChevronDown />}
                    </span>
                  </div>
                </div>
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse rounded-pill cursor-pointer ">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                      onClick={() => handelDeleteAction()}
                    >
                      <Trash3Fill />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="my-2 bg-white rounded d-flex flex-column ">
        <div className="checkin-details col-12 bg-white col-12 py-1  px-2 rounded">
          {collapseStates3[0] ? (
            <div className="checkin-details row align-items-top d-flex bg-white col-12 m-0">
              <DynamicDetailGrid
                customClassName="row-p-0 col-11"
                isExpandable={false}
                columns={5}
                data={OutbounDetailsData.OutboundDetailsExpanded}
              />
              <div className=" col d-flex align-items-center gap-2">
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                      onClick={() => toggleCollapse3(0)}
                    >
                      {collapseStates3[0] ? <ChevronUp /> : <ChevronDown />}
                    </span>
                  </div>
                </div>
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse rounded-pill cursor-pointer ">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                      onClick={() => handelDeleteAction()}
                    >
                      <Trash3Fill />
                    </span>
                  </div>
                </div>
              </div>
              <div className="mt-2 bg-white rounded py-1 px-4 detail-table-scroll">
                <Table
                  columns={columns}
                  data={OrderPickTicketDetailTable}
                  CheckboxStatus={false}
                  isStripped={true}
                  customClassName="transferDetailsTable"
                />
              </div>
            </div>
          ) : (
            <div className="checkin-details row m-0 align-items-center d-flex bg-white col-12 ">
              <DynamicDetailGrid
                customClassName=" col-11 row-p-0"
                isExpandable={false}
                columns={5}
                data={OutbounDetailsData.OutboundDetailsDefault}
              />
              <div className=" col d-flex align-items-center gap-2">
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 "
                      onClick={() => toggleCollapse3(0)}
                    >
                      {collapseStates3[0] ? <ChevronUp /> : <ChevronDown />}
                    </span>
                  </div>
                </div>
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse rounded-pill cursor-pointer ">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                      onClick={() => handelDeleteAction()}
                    >
                      <Trash3Fill />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="my-2 bg-white rounded d-flex flex-column ">
        <div className="checkin-details col-12 bg-white col-12 py-1  px-2 rounded">
          {collapseStates4[0] ? (
            <div className="checkin-details row align-items-top d-flex bg-white col-12 m-0">
              <DynamicDetailGrid
                customClassName="row-p-0 col-11"
                isExpandable={false}
                columns={5}
                data={OutbounDetailsData.OutboundDetailsExpanded}
              />
              <div className=" col d-flex align-items-center gap-2">
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                      onClick={() => toggleCollapse4(0)}
                    >
                      {collapseStates4[0] ? <ChevronUp /> : <ChevronDown />}
                    </span>
                  </div>
                </div>
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse rounded-pill cursor-pointer ">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                      onClick={() => handelDeleteAction()}
                    >
                      <Trash3Fill />
                    </span>
                  </div>
                </div>
              </div>
              <div className="mt-2 bg-white rounded py-1 px-4 detail-table-scroll">
                <Table
                  columns={columns}
                  data={OrderPickTicketDetailTable}
                  CheckboxStatus={false}
                  isStripped={true}
                  customClassName="transferDetailsTable"
                />
              </div>
            </div>
          ) : (
            <div className="checkin-details row m-0 align-items-center d-flex bg-white col-12 ">
              <DynamicDetailGrid
                customClassName=" col-11 row-p-0"
                isExpandable={false}
                columns={5}
                data={OutbounDetailsData.OutboundDetailsDefault}
              />
              <div className=" col d-flex align-items-center gap-2">
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 "
                      onClick={() => toggleCollapse4(0)}
                    >
                      {collapseStates4[0] ? <ChevronUp /> : <ChevronDown />}
                    </span>
                  </div>
                </div>
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse rounded-pill cursor-pointer ">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                      onClick={() => handelDeleteAction()}
                    >
                      <Trash3Fill />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* <div className="my-2 bg-white rounded d-flex flex-column">
        <div className="checkin-details col-12 bg-white col-12 py-1  px-2 ">
          {collapseStates2[0] ? (
            <div className="checkin-details row align-items-top d-flex bg-white col-12 ">
              <DynamicDetailGrid
                customClassName="my-2 col-11"
                isExpandable={false}
                columns={5}
                data={OutbounDetailsData.OutboundDetailsExpanded}
              />
              <div className=" col d-flex align-items-center gap-2">
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                      onClick={() => toggleCollapse2(0)}
                    >
                      {collapseStates2[0] ? <ChevronUp /> : <ChevronDown />}
                    </span>
                  </div>
                </div>
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse rounded-pill cursor-pointer ">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                      onClick={() => handelDeleteAction()}
                    >
                      <Trash3Fill />
                    </span>
                  </div>
                </div>
              </div>

              <div className="mt-2 bg-white rounded py-1 px-4 detail-table-scroll">
                <Table
                  columns={columns}
                  data={OrderPickTicketDetailTable}
                  CheckboxStatus={false}
                  isStripped={true}
                  customClassName="transferDetailsTable"
                />
              </div>
            </div>
          ) : (
            <div className="checkin-details row align-items-center d-flex bg-white col-12">
              <DynamicDetailGrid
                customClassName="my-2 col-11"
                isExpandable={false}
                columns={5}
                data={OutbounDetailsData.OutboundDetailsDefault}
              />
              <div className=" col d-flex align-items-center gap-2">
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 "
                      onClick={() => toggleCollapse2(0)}
                    >
                      {collapseStates2[0] ? <ChevronUp /> : <ChevronDown />}
                    </span>
                  </div>
                </div>
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse rounded-pill cursor-pointer ">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                      onClick={() => handelDeleteAction()}
                    >
                      <Trash3Fill />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="my-2 bg-white rounded d-flex flex-column">
        <div className="checkin-details col-12 bg-white col-12 py-1  px-2 ">
          {collapseStates3[0] ? (
            <div className="checkin-details row align-items-top d-flex bg-white col-12 ">
              <DynamicDetailGrid
                customClassName="my-2 col-11"
                isExpandable={false}
                columns={5}
                data={OutbounDetailsData.OutboundDetailsExpanded}
              />
              <div className=" col d-flex align-items-center gap-2">
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                      onClick={() => toggleCollapse3(0)}
                    >
                      {collapseStates3[0] ? <ChevronUp /> : <ChevronDown />}
                    </span>
                  </div>
                </div>
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse rounded-pill cursor-pointer ">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                      onClick={() => handelDeleteAction()}
                    >
                      <Trash3Fill />
                    </span>
                  </div>
                </div>
              </div>

              <div className="mt-2 bg-white rounded py-1 px-4 detail-table-scroll">
                <Table
                  columns={columns}
                  data={OrderPickTicketDetailTable}
                  CheckboxStatus={false}
                  isStripped={true}
                  customClassName="transferDetailsTable"
                />
              </div>
            </div>
          ) : (
            <div className="checkin-details row align-items-center d-flex bg-white col-12">
              <DynamicDetailGrid
                customClassName="my-2 col-11"
                isExpandable={false}
                columns={5}
                data={OutbounDetailsData.OutboundDetailsDefault}
              />
              <div className=" col d-flex align-items-center gap-2">
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 "
                      onClick={() => toggleCollapse3(0)}
                    >
                      {collapseStates3[0] ? <ChevronUp /> : <ChevronDown />}
                    </span>
                  </div>
                </div>
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse rounded-pill cursor-pointer ">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                      onClick={() => handelDeleteAction()}
                    >
                      <Trash3Fill />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="my-2 bg-white rounded d-flex flex-column">
        <div className="checkin-details col-12 bg-white col-12 py-1  px-2 ">
          {collapseStates4[0] ? (
            <div className="checkin-details row align-items-top d-flex bg-white col-12 ">
              <DynamicDetailGrid
                customClassName="my-2 col-11"
                isExpandable={false}
                columns={5}
                data={OutbounDetailsData.OutboundDetailsExpanded}
              />
              <div className=" col d-flex align-items-center gap-2">
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                      onClick={() => toggleCollapse4(0)}
                    >
                      {collapseStates4[0] ? <ChevronUp /> : <ChevronDown />}
                    </span>
                  </div>
                </div>
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse rounded-pill cursor-pointer ">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                      onClick={() => handelDeleteAction()}
                    >
                      <Trash3Fill />
                    </span>
                  </div>
                </div>
              </div>

              <div className="mt-2 bg-white rounded py-1 px-4 detail-table-scroll">
                <Table
                  columns={columns}
                  data={OrderPickTicketDetailTable}
                  CheckboxStatus={false}
                  isStripped={true}
                  customClassName="transferDetailsTable"
                />
              </div>
            </div>
          ) : (
            <div className="checkin-details row align-items-center d-flex bg-white col-12">
              <DynamicDetailGrid
                customClassName="my-2 col-11 "
                isExpandable={false}
                columns={5}
                data={OutbounDetailsData.OutboundDetailsDefault}
              />
              <div className=" col d-flex align-items-center gap-2">
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 "
                      onClick={() => toggleCollapse4(0)}
                    >
                      {collapseStates4[0] ? <ChevronUp /> : <ChevronDown />}
                    </span>
                  </div>
                </div>
                <div className="">
                  <div className="align-self-center d-flex flex-row-reverse rounded-pill cursor-pointer ">
                    <span
                      className="badge rounded-pill sph-text-bg-light-grey cursor-pointer rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 my-1"
                      onClick={() => handelDeleteAction()}
                    >
                      <Trash3Fill />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div> */}
      <CommonConfirmationModal
        customClassName="header-border"
        show={showConfModal}
        content={
          <>
            You are about to deallocate this shipment. This Shipment will be
            removed from Texas Warehouse <br />
            Are you sure?
          </>
        }
        onModalSubmit={onModalSubmit}
      />
    </>
  );
}
